import { useStandardToast } from '@cks-internal/react-base';
import { PropsWithChildren } from 'react';
import { setAxiosOnError } from '../lib/axios.tsx';

export const ErrorContainer = ({ children }: PropsWithChildren<{}>) => {
  const toast = useStandardToast();

  setAxiosOnError((error) => {
    const statusCode = error?.response?.status ?? 'Unknown';
    const url = error?.request?.responseURL ?? 'Unknown';
    const message = error?.message ?? 'No additional details provided.';

    const withDetails = (userMessage: string) =>
      `${userMessage}\n\nDetails:\n- Status: ${statusCode}\n- URL: ${url}\n- Message: ${message}`;

    switch (statusCode) {
      case 400:
        toast.errorToast(
          'Bad Request',
          withDetails('Your request could not be processed. Please check your input(s) and try again.')
        );
        break;

      case 401:
        toast.errorToast(
          'Unauthorized',
          withDetails('You don’t have permission to view this resource. Please check your credentials and try again.')
        );
        break;

      case 403:
        toast.errorToast('Forbidden', withDetails('You are not allowed to perform this action.'));
        break;

      case 404:
        toast.errorToast('Not Found', withDetails('The requested resource could not be found.'));
        break;

      case 408:
        toast.errorToast('Request Timed Out', withDetails('The server took too long to respond. Please try again.'));
        break;

      case 429:
        toast.errorToast(
          'Too Many Requests',
          withDetails('You are sending requests too quickly. Please wait and try again.')
        );
        break;

      case 500:
        toast.errorToast(
          'Server Error',
          withDetails('An unexpected error occurred on our end. Please try again later.')
        );
        break;

      case 502:
      case 503:
      case 504:
        toast.errorToast(
          'Service Unavailable',
          withDetails('The service is temporarily unavailable. Please try again later.')
        );
        break;

      default:
        toast.errorToast('Something went wrong', withDetails('We couldn’t complete your request.'));
        break;
    }
  });

  return <>{children}</>;
};
